import "../../../resources/less/Family/Onboarding/OnboardingFlow.less";
import OnboardingApi from "./OnboardingApi";
import OnboardingFlow from "./OnboardingFlow";
import OnboardingForm from "./OnboardingForm";
import { OnboardingMode } from "./OnboardingRules";

type Grecaptcha = {
  ready(callback: () => void): void;
  execute(siteKey: string, options: { action: string }): Promise<string>;
};

/** The token Google hands a human; empty when the page carries no site key. */
function captchaTokenFor(siteKey: string): () => Promise<string> {
  return () =>
    new Promise((resolve) => {
      const grecaptcha = (window as { grecaptcha?: Grecaptcha }).grecaptcha;
      if (siteKey === "" || grecaptcha === undefined) {
        resolve("");
        return;
      }
      grecaptcha.ready(() => {
        grecaptcha
          .execute(siteKey, { action: "family_onboarding" })
          .then(resolve, () => resolve(""));
      });
    });
}

export function bootstrapFamilyOnboarding(): OnboardingFlow | null {
  const root = $("#family-onboarding");
  if (root.length === 0) {
    return null;
  }
  const mode = (root.attr("data-mode") ?? "new") as OnboardingMode;
  return new OnboardingFlow(
    root,
    new OnboardingForm(root),
    new OnboardingApi(
      root.attr("data-email-url") ?? "",
      "",
      root.attr("data-account-url") ?? "",
      root.attr("data-progress-url") ?? "",
      root.attr("data-complete-url") ?? "",
    ),
    mode,
    {
      legalAge: Number(root.attr("data-legal-age")),
      maxChildren: Number(root.attr("data-max-children")),
      minPassword: Number(root.attr("data-min-password")),
    },
    $("#lang").text().trim() || "fr-CA",
    captchaTokenFor(root.attr("data-captcha-site-key") ?? ""),
    (url) => {
      window.location.href = url;
    },
  );
}

$(window).on("load", () => {
  bootstrapFamilyOnboarding();
});
